// extracted by mini-css-extract-plugin
export default {"stepHeading":"LoanApplicationStep_stepHeading__c5rDJ","stepName":"LoanApplicationStep_stepName__CLQR8","stepNavigation":"LoanApplicationStep_stepNavigation__Al4PS"};